<template>
  <b-modal
    id="modal-detail-contact"
    :title="$t('edit_contact')"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    size="lg"
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmit"
  >
    <validation-observer ref="contactValidation">
      <b-form>
        <b-row>
          <b-col class="col-md-6">
            <b-form-group
              :label="$t('company')"
              for="company"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('company')"
                rules="required"
              >
                <b-form-input
                  id="company"
                  v-model="contact.company_name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group
              :label="$t('inn')"
              for="info"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('inn')"
                rules="required|length:9"
              >
                <b-form-input
                  id="info"
                  v-model="contact.inn"
                  type="number"
                  on-key-press="if(this.value.length==9) return false;"
                  max="9"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <span
                  :class="contact.inn.length === 9 ? 'text-dark' : 'text-danger'"
                  class="float-right"
                >
                  {{ contact.inn.length }}
                  <span class="text-dark">
                    /9
                  </span>
                </span>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-12">
            <b-form-group
              :label="$t('address')"
              for="address"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('address')"
                rules="required"
              >
                <b-form-input
                  id="address"
                  v-model="contact.address"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group
              label="Email"
              for="mail"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Email')"
                rules="email"
              >
                <b-form-input
                  id="mail"
                  v-model="contact.email"
                  type="email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group
              :label="$t('contact.contacts')"
              for="contact"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('contact.contacts')"
                rules="required|length:12"
              >
                <b-form-input
                  id="contact"
                  v-model="contact.phone_number"
                  on-key-press="if(this.value.length==12) return false;"
                  max="12"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <span
                  :class="contact.phone_number.length === 12 ? 'text-dark' : 'text-danger'"
                  class="float-right"
                >
                  {{ contact.phone_number.length }}
                  <span class="text-dark">/12</span>
                </span>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-12">
            <b-form-group
              :label="$t('message')"
              for="message"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('message')"
                rules="required"
              >
                <b-form-textarea
                  id="message"
                  v-model="contact.description"
                  :placeholder="$t('message')"
                  rows="3"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BModal,
  BRow,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  name: 'ContactDetailModal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      required,
      email,
      contact: {
        company_name: '',
        description: '',
        address: '',
        inn: '',
        email: '',
        phone_number: null,
      },
    }
  },
  computed: {
    ...mapGetters('contacts', ['GET_ALL_CONTACTS']),
  },
  methods: {
    ...mapActions('contacts', ['FETCH_ALL_CONTACTS_LIST_ID', 'UPDATE_CONTRACT']),

    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.$refs.contactValidation.validate()
        .then(success => {
          if (success) {
            this.UPDATE_CONTRACT({
              id: this.GET_ALL_CONTACTS.id,
              ...this.contact,
            })
              .then(() => {
                this.$_okToast()
                this.FETCH_ALL_CONTACTS_LIST_ID(this.$route.params.id)
                this.$bvModal.hide('modal-detail-contact')
              })
          }
        })
    },

    showModal() {
      const {
        company_name,
        description,
        address,
        inn,
        phone_number,
        // eslint-disable-next-line no-shadow
        email,
      } = this.GET_ALL_CONTACTS
      this.contact.company_name = company_name
      this.contact.description = description
      this.contact.address = address
      this.contact.inn = inn
      this.contact.email = email
      this.contact.phone_number = phone_number
    },
  },
}
</script>

<style scoped>

</style>
